/**
 * Resolves formula subcategory keys: prefer SystemLine (Excel C13), then display name / formula alias.
 */
export function resolveFormulaSubcategoryKey(
    category: string,
    productName: string,
    prefilledValues?: Record<string, any>,
): string {
    const sel = prefilledValues?.[category];
    const candidates = [sel?.systemLine, productName, sel?.value, sel?.formulaProductName].filter(Boolean);
    return candidates[0] || productName;
}

export function buildSelectionsScope(prefilledValues?: Record<string, any>): Record<string, string> {
    const scope: Record<string, string> = {};
    if (!prefilledValues) return scope;
    Object.entries(prefilledValues).forEach(([prod, data]: [string, any]) => {
        const key = prod.replace(/\s+/g, "") + "_Selection";
        scope[key] = data.systemLine || data.value;
    });
    return scope;
}
